// extracted by mini-css-extract-plugin
export default {"component":"aR6Gq"};